// La línea flotante de «Hecho» y «Cancelar» (propuesta §5.6, P8): sale abajo de la columna 2 durante 8 s y dice qué
// pasa — «"Puerta nueva del CRM" hecho. Se lo decimos a Santi. · Deshacer» o «"Chatbot de Telegram" cancelado. Se lo
// decimos a Santi. · Decirle por qué · Deshacer». «Deshacer» lo deja todo como estaba sin que a Santi le haya llegado
// nada; «Decirle por qué» la cambia por un campo («¿Por qué? Lo verá Santi») con «Enviar» y deja de contar. Lo que va al
// centro sale cuando se va la línea (store `marcar` / `confirmarActo`). Si el centro no lo acepta, el contrato vuelve a
// su sitio y el aviso se queda arriba de la ventana y en la pared (AvisosActo, store `fallos`), no en esta línea.
// 04-11 (ADR D-037): un panel flotante de la oficina (como sus menús: gris de ventana, filo blanco tenue, sombra de lo que
// flota, esquinas de 12), que entra en 300 ms con la curva de Apple; botones en cápsula fantasma en blanco (el oro es solo
// «Enviar») y el campo de «¿Por qué?» es el `Campo` gris de la oficina.
import { Ban, Check, SendHorizontal } from 'lucide-react';
import { t } from '../../../i18n';
import { Boton, Campo } from '../ui';
import { LIMITES } from './api';
import { usePelotasStore } from './store';

const LINEA = 'flex items-center gap-3 rounded-o-m bg-oficina-elevada py-1.5 pl-4 pr-1.5 shadow-o-flota ring-1 ring-white/10 animate-in fade-in-0 slide-in-from-bottom-2 duration-300 ease-o-apple';
const BOTON = 'px-3.5 text-oficina-texto';

export function LineaActo({ alDeshacer }: { alDeshacer: () => void }) {
  const acto = usePelotasStore((s) => s.acto);
  const decirPorque = usePelotasStore((s) => s.decirPorque);
  const escribirPorque = usePelotasStore((s) => s.escribirPorque);
  const confirmarActo = usePelotasStore((s) => s.confirmarActo);
  if (!acto) return null;
  return (
    <div role="status" aria-live="polite" data-testid="linea-acto">
      {acto.porque ? (
        <div className={LINEA} data-testid="linea-porque">
          <Ban className="h-[18px] w-[18px] shrink-0 text-oficina-texto2" aria-hidden />
          <Campo
            autoFocus
            value={acto.nota}
            onChange={(e) => escribirPorque(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
                e.preventDefault();
                confirmarActo();
              }
            }}
            maxLength={LIMITES.nota}
            placeholder={t('oficinaV2.pelotas.acto.porque')}
            aria-label={t('oficinaV2.pelotas.acto.porque')}
            className="min-w-0 flex-1"
            data-testid="linea-porque-campo"
          />
          <Boton variante="primario" onClick={confirmarActo} data-testid="linea-porque-enviar">
            <SendHorizontal className="h-4 w-4" strokeWidth={2.2} aria-hidden />
            {t('oficinaV2.pelotas.acto.enviar')}
          </Boton>
        </div>
      ) : (
        <div className={LINEA} data-testid="linea-pendiente" data-motivo={acto.motivo}>
          {acto.motivo === 'cancelado' ? <Ban className="h-[18px] w-[18px] shrink-0 text-oficina-texto2" aria-hidden /> : <Check className="h-[18px] w-[18px] shrink-0 text-oficina-texto2" aria-hidden />}
          <p className="min-w-0 flex-1 py-2.5 text-o-cuerpo text-oficina-texto">
            {t(acto.motivo === 'cancelado' ? 'oficinaV2.pelotas.acto.cancelado' : 'oficinaV2.pelotas.acto.hecho', { titulo: acto.titulo })}
          </p>
          {acto.motivo === 'cancelado' ? (
            <Boton variante="fantasma" onClick={decirPorque} className={BOTON} data-testid="linea-decir-porque">
              {t('oficinaV2.pelotas.acto.decirPorque')}
            </Boton>
          ) : null}
          <Boton variante="fantasma" onClick={alDeshacer} className={BOTON} data-testid="linea-deshacer">
            {t('oficinaV2.pelotas.acto.deshacer')}
          </Boton>
        </div>
      )}
    </div>
  );
}
